module.exports = __webpack_public_path__ + "img/section4-1-desktop.d7c5abe8.png";